export default __webpack_public_path__ + "static/media/54.0f4761e9.jpeg";